<template>
  <div class="triangle-bg py-40 flex items-center justify-center">
    <div class="relative bg-white border-4 border-blue rounded-lg px-8 pb-12 w-full max-w-md">
      <div class="relative form-title transform -translate-y-1/2 flex z-20 -ml-2">
        <h2 class="w-auto bg-blue text-white text-xl uppercase font-bold px-2 py-1 rounded">Reset Password</h2>
      </div>
      <form-main
        :handleCancel="cancelRequest"
        :handleSubmit="submitRequest"
        :fields="fields"
        :values="loginInfo"
        submitText="Send Reset Link"
        submitColor="purple"
        submitAlign="right" />
      <p class="mt-4" v-if="sending">Sending</p>
      <p class="mt-4" v-else-if="message" v-html="message" />
    </div>
  </div>
</template>

<script>
import FormMain from '../../components/forms/FormMain'

export default {
  components: {
    FormMain
  },
  data: function() {
    return {
      sending: false,
      message: null,
      fields: [
        {
          fields: {
            label: 'Email*',
            name: 'email',
            type: 'email',
            width: 'full'

          }
        }
      ],
      loginInfo: {
        email: null,
        password: null
      }
    }
  },
  head() {
    return {
      title: 'Forgot Password'
    }
  },
  mounted: async function() {
    if(this.$store.state.loggedIn) {
      this.$router.push('/account')
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    }
  },
  methods: {
    cancelRequest() {
      this.$router.push('/login')
    },
    async submitRequest(form) {
      this.sending = true
      this.message = null
      let status = await this.$okta.forgotPassword(form.email)
      this.sending = false
      if(status == true) {
        this.message = 'Success. Please check your email.'
      } else {
        this.message = 'We couldn’t find your account.'
      }
    }
  }
}
</script>